export const RoleNames = {
  STUDENT: 'student',
  UNREGISTERED: 'unregistered',
  VOLUNTEER: 'volunteer',
};
